import { SectionTitle } from "../../common/SectionTitle/SectionTitle";
import features from '../../../assets/icons/features.svg';
import { styled } from '@mui/system';
import { Grid } from "../../common/Grid/Grid";
import { GridItem } from "../../common/Grid/GridItem";
import { BasicCard } from "../../common/BasicCard/BasicCard";
import plugins from '../../../assets/icons/plugins.svg';
import dora from '../../../assets/icons/dora.svg';
import releasesManagement from '../../../assets/icons/releases-management.svg';
import scorecard from '../../../assets/icons/scorecard.svg';
import management from '../../../assets/icons/management.svg';
import gamification from '../../../assets/icons/gamification.svg';
import customDashboard from '../../../assets/icons/custom-dashboard.svg';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const AstrolabeContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: '96px',
    paddingBottom: '96px',
    '@media (max-width: 1024px)': {
        paddingTop: '48px',
        paddingBottom: '48px',
        paddingLeft: '16px',
        paddingRight: '16px',
    }
});

export const Astrolabe = () => {
    const { t } = useTranslation();

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.5,
                ease: "easeOut"
            }
        }
    };

    return (
        <AstrolabeContainer>
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
            >
                <SectionTitle
                    title={t('astrolabe.title')}
                    secondaryTitle={t('astrolabe.subtitle')}
                    logo={features}
                />
            </motion.div>

            <motion.div
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
            >
                <Grid columns={4} rows={2} mobileColumns={2} mobileRows={4}>
                    <GridItem>
                        <motion.div variants={itemVariants}>
                            <BasicCard icon={plugins} title={t('astrolabe.features.pluginsManagement')} />
                        </motion.div>
                    </GridItem>
                    <GridItem>
                        <motion.div variants={itemVariants}>
                            <BasicCard icon={management} title={t('astrolabe.features.usersGroups')} />
                        </motion.div>
                    </GridItem>
                    <GridItem>
                        <motion.div variants={itemVariants}>
                            <BasicCard icon={customDashboard} title={t('astrolabe.features.customDashboard')} />
                        </motion.div>
                    </GridItem>



                    <GridItem>
                        <motion.div variants={itemVariants}>
                            <BasicCard icon={releasesManagement} title={t('astrolabe.features.releasesManagement')} />
                        </motion.div>
                    </GridItem>
                    <GridItem>
                        <motion.div variants={itemVariants}>
                            <BasicCard icon={scorecard} title={t('astrolabe.features.scorecard')} />
                        </motion.div>
                    </GridItem>

                    <GridItem>
                        <motion.div variants={itemVariants}>
                            <BasicCard icon={gamification} title={t('astrolabe.features.gamification')} />
                        </motion.div>
                    </GridItem>
                    <GridItem>
                        <motion.div variants={itemVariants}>
                            <BasicCard icon={dora} title={t('astrolabe.features.doraMetrics')} />
                        </motion.div>
                    </GridItem>

                    <GridItem>
                        <motion.div variants={itemVariants}>
                            <BasicCard title={t('astrolabe.features.andMore')} color="#021A1A" backgroundColor="#00E378" />
                        </motion.div>
                    </GridItem>
                </Grid>
            </motion.div>
        </AstrolabeContainer>
    );
};
